import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, throwError } from "rxjs";
import { catchError, switchMap, take, tap } from "rxjs/operators";
import { TouchSequence } from "selenium-webdriver";

@Injectable({
  providedIn: "root",
})
export class PagesSlugsService {
  constructor(private http: HttpClient) { }

  private PagesSlugsSubject = new BehaviorSubject<any[]>(null);
  pagesSlugs$: Observable<any[]> = this.PagesSlugsSubject.asObservable();

  private flatPagesSlugsSubject = new BehaviorSubject<any[]>(null);
  flatPagesSlugs$: Observable<any[]> =
    this.flatPagesSlugsSubject.asObservable();

  private PostsSlugsSubject = new BehaviorSubject<any[]>(null);
  postsSlugs$: Observable<any[]> = this.PostsSlugsSubject.asObservable();

  private PostsCategoriesSubject = new BehaviorSubject<any[]>(null);
  postsCategories$: Observable<any[]> =
    this.PostsCategoriesSubject.asObservable();

  private ProductsSubjects = new BehaviorSubject<any[]>(null);
  products$: Observable<any[]> = this.ProductsSubjects.asObservable();
  private BrandsSubjects = new BehaviorSubject<any[]>(null);
  brands$: Observable<any[]> = this.BrandsSubjects.asObservable();
  private CategorySubjects = new BehaviorSubject<any>(null);
  Category$: Observable<any> = this.CategorySubjects.asObservable();

  getAllPages(culture) {
    return this.http
      .post<any[]>(`/Pages/GetAllPages/0/2/0/${culture}`, {})
      .pipe(
        tap((res) => res && this.PagesSlugsSubject.next(res)),
        catchError((err) => {
          throwError(err);
          return of([]);
        })
      );
  }

  getAllPagesFlat(status, culture) {
    return this.http
      .get<any[]>(`/Pages/GetAllPagesFlat/0/0/${status}/${culture}`)
      .pipe(
        tap((res) => res && this.flatPagesSlugsSubject.next(res)),
        catchError((err) => {
          throwError(err);
          return of([]);
        })
      );
  }

  getPostsCategories(CategoryTypeId, CultureId) {
    const data = {
      "pagination": {
        "pageSize": 10000000,
        "pageNumber": 0
      },
      "eCategoryTypes": CategoryTypeId,
      "searchText": ""
    }
    console.log(CultureId);

    return this.http
      .post<any>(`/CategoriesApi/GetAllCategories`, data)
      .pipe(tap((res) => {
        if (res && res.data.length > 0) {
          const categoreies = res.data.map((element) => {

            let categoryDetails = element.categoryDetails.find((ele) => ele.cultureId
              == CultureId)
            if (!categoryDetails) return null;
            console.log(categoryDetails);

            delete categoryDetails.id;
            return { ...element, ...categoryDetails }
          }).filter(item => item !== null);

          this.PostsCategoriesSubject.next(categoreies
          )
        }
      }
      ));
  }

  getPostsByCategory(searchObj, CultureId) {
    return this.http
      .post<any[]>(`/BolgArchive/GetPostsForAdmin`, searchObj)
      .pipe(
        tap((res: any) => {

          if (res) {
            const items = res.list.reduce((acc, item) => {
              if (item.postCultures.some(post => Number(post.culture?.id) === Number(CultureId))) {
                acc.push(item);
              }
              return acc;
            }, []);
            res.list = [...items];
          }
          this.PostsSlugsSubject.next(res)
        }),
        catchError((err) => {
          throwError(err);
          return of([]);
        })
      );
  }
  getCategoryById(id: number) {

    id = +id
    return this.http.get<any>(`/CategoriesApi/GetCategoriesById/${id}`)

  }
  getProductById(id) {
    id = +id
    return this.http.get<any>(`/ProductApi/GetProductById/${id}`)
  }
  getAllBrands(cultureId: number) {
    return this.http.post<any[]>(`/brands/GetAllBrandFlat/${cultureId}`, {}).pipe(

      tap((res) => {

        res && this.BrandsSubjects.next(res)
      }),
      catchError((err) => {
        throwError(err);
        return of([]);
      })
    );
  }
  resetSubjects() {
    this.PagesSlugsSubject.next(null);
    this.PostsSlugsSubject.next(null);
    this.flatPagesSlugsSubject.next(null);
  }
  GetAllProductsFlats(cultureId: number, categoryId) {
    return this.http
      .get<any[]>(`/ProductApi/GetProductsFlat/${cultureId}/${categoryId}`)
      .pipe(
        tap((res) => res && this.ProductsSubjects.next(res)),
        catchError((err) => {
          throwError(err);
          return of([]);
        })
      );
  }
}
